export const HOME = '/';
export const LIST = '/projects';
export const NEW_PROJECT = LIST + '/new';
export const VIEW_PROJECT = LIST + '/:id';
export const EDIT_PROJECT = LIST + '/:id/edit';

// prettier-ignore
export const LIST_REGEX = new RegExp('\/projects$');
// prettier-ignore
export const NEW_PROJECT_REGEX = new RegExp('\/projects\/new$');
// prettier-ignore
export const VIEW_PROJECT_REGEX = new RegExp('\/projects\/(?<id>[^\/]+)$');
// prettier-ignore
export const EDIT_PROJECT_REGEX = new RegExp('\/projects\/(?<id>[^\/]+)\/edit$');
